import type { I_MainState } from "@/store/modules/main/lib/models/interfaces";

const state: I_MainState = {
  interfaceLang: "ru_RU",
};

export default state;
